import React, { useState, useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../../../redux/hooks';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';

// Components 
import Box from '@mui/material/Box';
import moment from 'moment';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

interface Props { 
    item: any,
    handler: any; 
    isLast: boolean
}; 

const NoteRow: React.FC<Props> = ({ item, handler, isLast }) => {
    const { t } = useTranslation(); 
    const navigate = useNavigate(); 
    const { consultationNoteId } = useParams(); 

    const colors = useAppSelector(state => state.theme.colors); 
    const isConsultationsDropdownOpened = useAppSelector(state => state.consultation.isConsultationsDropdownOpened); 
    const selectedConsultationNote = useAppSelector(state => state.consultation.selectedConsultationNote); 

    const [formattedDate, setFormattedDate] = useState(''); 
    const isSelected = consultationNoteId === item?._id;

    const handleConsultation = () => { 
        if (isSelected) return; // Don't reload if already on the page
        navigate(`/consultation/${item.consultationId}/note/${item?._id}`);
    }; 

    const handleDropdown = (e: any) => { 
        e.stopPropagation(); // Prevent row click from firing
        handler(e, item); 
    }; 

    useEffect(() => { 
        if (item?.updatedAt) { 
            setFormattedDate(moment(item.updatedAt).utc(true).format('LLL')); 
        }
    },[item]); 

    return (
        <Box
            onClick={handleConsultation}
            sx={{ 
                display: 'flex',
                cursor: 'pointer', 
                flexDirection: 'row', 
                alignItems: 'center',
                marginBottom: isLast ? '20vh' : 1.5, 
                width: '95%',
                borderRadius: 2, 
                padding: 1, 
                fontSize: 14, 
                borderStyle: 'solid', 
                borderWidth: isSelected ? 2 : 1, 
                borderColor: isSelected ? colors?.main : 'rgb(220, 220, 220)', 
                backgroundColor: isSelected ? colors?.sidebarSelectedItemBackground : (isConsultationsDropdownOpened && (selectedConsultationNote?._id === item?._id)) ? colors?.sectionHover : 'transparent',
                '&:hover': { 
                    backgroundColor: isSelected ? colors?.sidebarSelectedItemBackground : colors?.sectionHover, 
                    borderColor: isSelected ? colors?.main : 'rgb(180, 180, 180)' 
                }
            }}
        >
            <Box
                sx={{ 
                    display: 'flex',
                    flexDirection: 'column',
                    flexGrow: 1,
                    overflow: 'hidden',
                    pr: 1,
                }}  
            >
                <Box
                    sx={{ 
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        fontSize: 14,  
                        width: '100%', 
                        fontWeight: isSelected ? 600 : 400,
                        color: colors?.text,
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                    }}
                >
                    {item?.title || t('newConsultationTitle')}
                </Box>
                <Box
                    sx={{ 
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        width: '100%',
                        fontSize: 12, 
                        color: 'rgb(150, 150, 150)',
                        mt: 0.5,
                    }}
                >
                    {formattedDate}
                </Box>
            </Box>

            <Box
                onClick={handleDropdown}
                sx={{ 
                    display: 'flex', 
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'center',
                    borderRadius: '50%',
                    color: colors?.text,
                    p: 0.5,
                    ml: 1,
                    '&:hover': { backgroundColor:  'rgba(0, 0, 0, 0.1)' } 
                }}
            >
                { (isConsultationsDropdownOpened && (selectedConsultationNote?._id === item?._id)) ?
                <KeyboardArrowUpIcon sx={{ fontSize: 22 }} /> : <MoreVertIcon sx={{ fontSize: 22 }} />}
            </Box>
        </Box>
    );
};

export default NoteRow;